import {fetcher, postHeaders} from './fetcher'

export const switchAccount = ({accountId, authenticityToken}) => {
  const opts = postHeaders({authenticityToken, body: {}})

  return fetcher(`/api/accounts/${accountId}/switch`, opts)
}
